import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import { SwitchLine } from '../controls';
import css from './AdvancedSettings.css';
import { sitePropType } from './propTypes';

const AppClipsSection = ({ site, readOnly, onSitePatch }) => (
    <section className={css.formSection}>
        <h4>
            <Translate id="STATIC.PAGES.APPS_CONFIGURATION.APP_CLIPS_TITLE" />
        </h4>
        <SwitchLine
            checked={!!site.is_app_clip}
            disabled={readOnly}
            label={<Translate id="STATIC.PAGES.APPS_CONFIGURATION.APP_CLIP" />}
            onChange={value => onSitePatch({ is_app_clip: value })}
        />
    </section>
);

AppClipsSection.propTypes = {
    onSitePatch: PropTypes.func.isRequired,
    readOnly: PropTypes.bool.isRequired,
    site: sitePropType.isRequired,
};

export default AppClipsSection;
